import _ from 'lodash'
import { Document, isTag, isText, type ChildNode, type Element } from 'domhandler'
import { parseDocument } from 'htmlparser2'
import type { HtmlFile } from '../../../types'

const isSignificantNonElement = (node: ChildNode): boolean => {
    if (isText(node)) {
        return _.trim(node.data) !== ''
    }
    return true
}

export const parseStructureToAst = (htmlFile: HtmlFile): Document => {
    const doc = parseDocument(htmlFile.content, { decodeEntities: true })

    const rootElements = doc.children.filter(isTag)
    if (rootElements.length !== 1) {
        throw new Error(`Structure must have a single root element, found ${rootElements.length}`)
    }

    const rootElement = rootElements[0]
    let nonElementNodeCount = 0

    for (const child of doc.children) {
        if (!isTag(child) && isSignificantNonElement(child)) {
            nonElementNodeCount++
        }
    }

    const countNonElementNodes = (node: Element): void => {
        for (const child of node.children) {
            if (isTag(child)) {
                countNonElementNodes(child)
            } else if (isSignificantNonElement(child)) {
                nonElementNodeCount++
            }
        }
    }

    countNonElementNodes(rootElement)

    if (nonElementNodeCount > 0) {
        throw new Error(`Structure contains ${nonElementNodeCount} non-element node(s) (text/comments)`)
    }

    return doc
}
